import { useMergedRef } from '@/hook';

import type { VBaseSelectProps } from '../VBaseSelect';
import { useVBaseSelectContext } from '../VBaseSelect';
import { VButton } from '../VButton';
import type { VButtonProps } from '../VButton/type';
import { VFlex } from '../VFlex';
import { KeyboardArrowDown, KeyboardArrowUp } from '../asset';
import twStyle from './style';

const VInnerDropdown = ({
  children,
  ref,
  ...rest
}: React.PropsWithChildren<
  VButtonProps &
    Pick<VBaseSelectProps, 'readOnly'> &
    React.RefAttributes<HTMLButtonElement>
>) => {
  const { $displayValue, itemListVisible } = useVBaseSelectContext();
  const refs = useMergedRef(
    ref,
    $displayValue as React.RefObject<HTMLButtonElement>,
  );
  const Icon = itemListVisible ? KeyboardArrowUp : KeyboardArrowDown;
  const style = twStyle({ size: rest.size });

  return (
    <VButton ref={refs} {...rest} className="px-1!">
      <VFlex items="center" gap={0.25}>
        <VFlex className={style.childWrapper} items="center" gap={0.25}>
          {children}
        </VFlex>
        <div
          aria-disabled={rest.disabled || rest.loading}
          className={style.divider}
        />
        <Icon />
      </VFlex>
    </VButton>
  );
};

export default VInnerDropdown;
